import { RIGHTS_AND_MODULE_ACCORDANCE } from '@app/constants';
import type { NAccessRights } from '@app/types';

export const hasModuleRight = (
  servicerightsid: NAccessRights.EntityId | undefined,
  moduleRights: NAccessRights.ModelAccessRights['Modules']
) => {
  if (!servicerightsid || !moduleRights || moduleRights?.length === 0)
    return true;
  if (!RIGHTS_AND_MODULE_ACCORDANCE[servicerightsid]) return true;

  const moduleId = RIGHTS_AND_MODULE_ACCORDANCE[servicerightsid];
  const currentModuleRights = (moduleRights || []).find(
    (item) => item.RightType === moduleId
  );

  return !!(currentModuleRights && currentModuleRights.Allowed);
};
